import type { TimePreset } from '@better-lights/core';
import { create } from 'zustand';

export interface RenderJobView {
  id: string;
  projectId: string;
  time: TimePreset;
  status: 'uploading' | 'queued' | 'running' | 'succeeded' | 'failed' | 'canceled';
  credits: number;
  partialUrl?: string;
  error?: string;
  createdAt: number;
}

export interface ProjectRenderRun {
  projectId: string;
  startedAt: number;
  total: number;
  phase: 'preparing' | 'rendering' | 'done';
  error: string | null;
  jobIds: string[];
}

export const useRenders = create<{ jobs: Record<string, RenderJobView>; runs: Record<string, ProjectRenderRun> }>(
  () => ({
    jobs: {},
    runs: {},
  }),
);

export function setJob(job: RenderJobView): void {
  useRenders.setState((s) => ({ jobs: { ...s.jobs, [job.id]: { ...s.jobs[job.id], ...job } } }));
}

export function setRun(projectId: string, patch: Partial<ProjectRenderRun>): void {
  useRenders.setState((s) => {
    const prev = s.runs[projectId] ?? {
      projectId,
      startedAt: Date.now(),
      total: 0,
      phase: 'preparing' as const,
      error: null,
      jobIds: [],
    };
    return { runs: { ...s.runs, [projectId]: { ...prev, ...patch } } };
  });
}

export const isTerminal = (s: RenderJobView['status']) => s === 'succeeded' || s === 'failed' || s === 'canceled';
